//import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC } from "react";
import { Bar } from "react-chartjs-2";
import styled from "styled-components";
import { StuntTypeProp } from "../../../CustomTypes/Filters";
//import { useDashboardData } from "../../../Hooks/useDashboard";
import { useHookForApi } from "../../../Hooks/useHookForApi";
//import LoadingIndicator from "../../LoadingIndicator";
import "./dashboard.scss";
import { errorToast } from "../../../Utils/toastMessage";
import CustomToast from "../../CustomToast/CustomToast";

const ChartWarapper = styled.div`
  max-width: auto;
  margin: 0 auto;
`;

const StoreOrderIssue: FC<StuntTypeProp> = (stuntType) => {
  const onSuccess = (data: any) => {
    if (data.isAxiosError && data.name === 'Error' && data.message === "Network Error") {
      errorToast(JSON.stringify(`Unable to connect with StoreOrder service and possible reason is: (${data})`));
    }
  };
  const onError = (error: any) => {
    //console.clear()
  };

  //purchaseorders/dashboard
  const {
    isLoading: isDataLoading,
    data:response,
    isFetching,
  //} = useDashboardData(onSuccess, onError, `storeorders/dashboard${stuntType.stuntType}`);
  } = useHookForApi(onSuccess, onError ,0,0, `storeorders/dashboard${stuntType.stuntType}`);

  const labels = ["SKU Issue", "QTY Issue"];
  //const dataForCalulation = [data?.expected, data?.received];
  //const customLabels = labels.map((label, index) => `${data?.totalCount}`);

  const dashboardData = {
    labels: labels,
    responsive: true,
    offset: false,
    datasets: [
      {
        stack: 'arbitraryStackKey',
        label: "QTY Issue",
        //pointStyle: "rectRounded",
        backgroundColor: "#F8B515",
        barThickness: 40,
        categoryPercentage: 1,
        //pointStyle: "triangle",
        data: [response?.data?.qtyIssue]
      },
      {
        stack: 'arbitraryStackKey',
        label: "SKU Issue",
        //pointStyle: "rectRounded",
        backgroundColor: "#274568",
        barThickness: 40,
        categoryPercentage: 1,
        data: [response?.data?.skuIssue]
      }
    ]
  }

  const options = {
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      }
      // responsive: true,
      // maintainAspectRatio: false
    }
  }

  return (
    <>
      <div className="ln-u-soft colour" style={{position:'relative', height:'auto'}}>
      {/* <div style={{ width: '50%',border: 'solid',float: 'right' }}> */}
        <div className="position" style={{width: '135px'}}>
          {/* <div className="parent" style={{ height: 'auto', width: '51%', border: 'solid', float: 'right'}}> */}
          <div className="parent" style={{ float: 'right'}}>
            SKU Issue ({response?.data?.skuIssue}) &nbsp;
            <div className="child storeSkuIssues"></div>
          </div>
          {/* <div className="parent" style={{ width: '51%', border: 'solid', float: 'right' }}> */}
          <div className="parent" style={{float: 'right' }}>
            QTY Issue ({response?.data?.qtyIssue}) &nbsp;
            <div className="child storeSkuQtyIssues"></div>
          </div>
        </div>
        {/* <div style={{width: '100%',  width: '50%',border: 'solid' }}> */}
        <div className="chartPosition" style={{marginTop:'180px',}}>
          <ChartWarapper>
            <Bar
              //pointStyle="star"
              data={dashboardData}
              //height={220}
              options={options}
            />
          </ChartWarapper>
        </div>



        {/* <GridWrapper equalHeight>
          <GridItem size="1/2">
            <ChartWarapper>
              <Bar
                //pointStyle="star"
                data={dashboardData}
                //height={220}
                options={options}
              />
            </ChartWarapper>
          </GridItem>
          <GridItem size="1/2">
            <div className="">
              <div className="parent">
                SKU Issue ({data?.received}) &nbsp;
                <div className="child storeSkuIssues"></div>
              </div>
              <div className="parent">
                QTY Issue ({data?.expected}) &nbsp;
                <div className="child storeSkuQtyIssues"></div>
              </div>
            </div>
          </GridItem>
        </GridWrapper> */}
      </div>
      <CustomToast />
    </>
  );
};

export default StoreOrderIssue;